import React, { useState, useEffect } from "react";
import axios from 'axios';
import { getEnquiry } from '../utils/api';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

const EnquiryListLayer = () => {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        // Fetch data
        axios.get(process.env.REACT_APP_API_BASE_URL+"enquiry-all")
            .then(response => {
                setPosts(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);

    useEffect(() => {
        // Initialize DataTable after posts are rendered
        if (posts.length > 0) {
            const table = $('#dataTable').DataTable({
                pageLength: 10,
            });

            // Cleanup function
            return () => {
                
            };
        }
    }, []); // Re-run this effect when posts change
    const formatDate = (dateString) => {
        return format(new Date(dateString), 'dd-MM-yyyy');
    };

    return (
            <div className="card basic-data-table">
                <div className="card-header">
                    <h5 className="card-title mb-0"></h5>
                </div>
                
                <div className="card-body">
                    <table
                        className="table bordered-table mb-0"
                        id="dataTable"
                        data-page-length={10}
                    >
                        <thead>
                            <tr>
                                <th scope="col">S.L</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Message</th>
                                <th scope="col">Issued Date</th>
                            </tr>
                        </thead>
                        <tbody>
                        {posts.map((post,i) => (
                            <tr>
                                <td>
                                    <div className="form-check style-check d-flex align-items-center">
                                        <label className="form-check-label">{i+1}</label>
                                    </div>
                                </td>
                                <td key={post.id}>
                                    <Link to="#" className="text-primary-600">
                                    {post.name}
                                    </Link>
                                </td>
                                <td key={post.id}>
                                    <div className="d-flex align-items-center">
                                        <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                        {post.email}
                                        </h6>
                                    </div>
                                </td>
                                <td key={post.id}>{post.message}</td>
                                <td key={post.id}>{formatDate(post.createdAt)}</td>
                            </tr>
                          ))}
                        </tbody>
                    </table>
                </div>
            </div>
    )
}

export default EnquiryListLayer